











































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';

@Component
export default class CategoryBackLogView extends Vue {
  public items: Common.Category_BackLog[] = new Array(0);
  public params: Common.Category_BackLogQuery = new Common.Category_BackLogQuery();
  public importQuery = new Common.ImportQuery('カテゴリー', 'Category_BackLog');
  public exportQuery = new Common.ExportQuery('カテゴリー', this.params);
  public sortOptions: any = [{ value: 'Code', text: 'カテゴリー' }];
}
